import { useState } from 'react'

import './Contact.scss'

import { FiMail } from 'react-icons/fi'
import { FaPhone } from 'react-icons/fa'
import { client } from '../../client'

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: '',
  })
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const { username, mobile, email, message } = formData

  const handleChangeInput = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = () => {
    setLoading(true)

    // console.log(username, mobile, email, message)

    setLoading(false)
    setIsFormSubmitted(true)

    const contact = {
      _type: 'contact',
      name: formData.username,
      mobile: formData.mobile,
      email: formData.email,
      message: formData.message,
    }

    client
      .create(contact)
      .then(() => {
        setLoading(false)
        setIsFormSubmitted(true)
      })
      .catch((err) => console.log(err))
  }

  return (
    <div className='contact' id='contact'>
      <h1>Contact Me</h1>
      <div className='contact-cards'>
        <div className='contact-card'>
          <FiMail />
          <a href='mailto:riyad_ibit@yahoo.com' className='p-text'>
            riyad_ibit@yahoo.com
          </a>
        </div>
        <div className='contact-card'>
          <FaPhone />
          <a href='tel:+8801625558899' className='p-text'>
            +880 1625558899
          </a>
        </div>
      </div>

      {!isFormSubmitted ? (
        <div className='contact-form'>
          <div className='input-wrapper'>
            <input
              className='p-text'
              type='text'
              placeholder='Your Name'
              name='username'
              value={username}
              onChange={handleChangeInput}
            />
          </div>
          <div className='input-wrapper'>
            <input
              className='p-text'
              type='email'
              placeholder='Your Email'
              name='email'
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          <div className='input-wrapper'>
            <input
              className='p-text'
              type='email'
              placeholder='Your Mobile Number'
              name='mobile'
              value={mobile}
              onChange={handleChangeInput}
            />
          </div>
          <div>
            <textarea
              className='p-text'
              placeholder='Your Message'
              value={message}
              name='message'
              onChange={handleChangeInput}
            />
          </div>
          <button type='button' className='p-text' onClick={handleSubmit}>
            {!loading ? 'Send Message' : 'Sending...'}
          </button>
        </div>
      ) : (
        <div>
          <h3 className='head-text'>Thank you for getting in touch!</h3>
        </div>
      )}
    </div>
  )
}

export default Contact
